<!DOCTYPE html>
<!--[if IE 8 ]><html class="ie" xmlns="http://www.w3.org/1999/xhtml" xml:lang="en-US" lang="en-US"> <![endif]-->
<!--[if (gte IE 9)|!(IE)]><!-->
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en-US" lang="en-US">
<!--<![endif]-->

<head>


</head>

<body class="body popup-loader counter-scroll">

  <!-- wrapper -->
  <div id="wrapper">
    <!-- page-title -->
    <div class="page-title">
      <div class="tf-tsparticles">
        <div id="tsparticles1" data-color="#fff" data-line="#fff"></div>
      </div>
      <div class="tf-container">
        <div class="row">
          <div class="col-12">
            <div class="content">
              <h1 class="title">Privacy Policy</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /page-title -->
    <div class="main-content">
      <div class="tf-container">
        <div class="row">
          <div class="col-12">
            <div class="content">
              <ul class="">
                <div>
                  <p>The following data protection instructions clarify the collection and processing of your personal
                    data
                    when using the website https://www.gogomoneymaker.com<br />
                    These privacy notices also include the collection and processing of your data on external website or
                    online services connected to this website (such as Google or social media profiles).<br />
                    The definitions and descriptions of the data collection and processing as well as of those
                    responsible
                    for this data collection or processing correspond to the definition in Art. 4 of the General Data
                    Protection Regulation (GDPR) as of 25.05.2018.<br /><br />
                    In pursuance of Section 13 of Legislative Decree no. 196/2003 PersonalData (hereinafter the Privacy
                    Code), We inform you that the treatment of Personal Data (name, surname, email address and any
                    further
                    Personal Data indicated in the message) by you spontaneously provided filling out the contact form
                    on
                    the website https://www.gogomoneymaker.com/ (our website) will respect the principles of fairness,
                    legality and transparency and protection of your privacy and your rights. Please note that this
                    Policy
                    also contains the information required by art. 13 of Regulation (EU) 679/2016, concerning the
                    protection
                    of natural persons with regard to the processing of Personal Data (hereinafter "GDPR"), which will
                    become applicable in all the Member States of the European Union and belonging to the European
                    Economic
                    Area from May 25, 2018.
                  </p>
                  <br />
                  <br /><br />
                  <div class="content">
                    <h2 class="title mb-6">Personal data</h2>
                    <p>By "personal data" is meant basically all information that can be used to draw conclusions about
                      a
                      natural person or to identify a natural person.
                      A natural person is considered to be identifiable if he / she uses an identifier (eg a name), a
                      number,
                      a specific location of an online mark (eg a cookie) or other special features (eg physical,
                      psychological, genetic, economic, cultural or social features) can be clearly
                      identified.<br /><br />
                      We may collect and process some data which you directly and voluntarily provide to
                      https://www.gogomoneymaker.com or all of the following information you make available to if you
                      register,
                      download or use the Services, such as your:
                    <div>
                      <ul>
                        <li>Name</li><br />
                        <li>Email Address</li><br />
                        <li>Mailing Address</li><br />
                        <li>Phone Number</li><br />
                        <li>Interests</li><br />
                        <li>Other Registration Information</li>
                      </ul>
                    </div>

                    <p>Customer Support or Technical Information you provide when you contact us with questions about
                      your use
                      of the Services.<br /><br />In addition to the information you provide to
                      https://www.gogomoneymaker.com,
                      the Services may automatically and anonymously collect and process additional data automatically,
                      this
                      data may include your:
                    <div>
                      <ul>
                        <li>Device Registration Data (for example, the type of mobile device you use, your mobile
                          device’s
                          unique device or advertising ID, IP address, operating system and browser type)</li><br />
                        <li>Device Settings (for example, your language preference)</li><br />
                        <li>Mobile Carrier</li><br />
                        <li>Information about how you use the Services (for example, how many times you use the Services
                          each day)</li><br />
                        <li>Requested and Referring URLs</li><br />
                        <li>Location Data collected through your Device (including, for example, precise location data
                          such
                          as GPS and WiFi information)</li>
                      </ul>
                    </div>


                    <br />
                    <br /><br />
                    <h2 class="title mb-6">Use of Data</h2>
                    We may collect data for various purposes:
                    <div>
                      <ul>
                        <li>To provide and maintain our Service</li><br />
                        <li>To notify you about changes to our Service</li><br />
                        <li>To allow you to participate in interactive features of our Service when you choose to do
                          so</li>
                        <br />
                        <li>To provide customer support</li><br />
                        <li>To gather analysis or valuable information so that we can improve our Service</li><br />
                        <li>To monitor the usage of our Service</li><br />
                        <li>To detect, prevent and address technical issues</li><br />
                        <li>To provide you with news, special offers and general information about other goods,
                          services and
                          events which we offer that are similar to those that you have already purchased or enquired
                          about unless you have opted not to receive such information</li>
                      </ul>
                    </div>
                    If you access the Services through a browser, your browser may allow you to adjust your browser
                    settings so
                    that “Do Not Track” requests are sent to the websites that you visit. However,
                    https://www.gogomoneymaker.com
                    will not disable tracking technology that may be active on the Services in response to any Do Not
                    Track
                    requests that we receive from your browser. You can change your privacy preferences regarding the
                    use of
                    cookies and other similar technologies through your browser. You may set your browser to accept
                    all cookies,
                    block certain cookies, require our consent before a cookie is placed in your browser, or block all
                    cookies.
                    Blocking all cookies will affect your online experience and may prevent you from enjoying the full
                    features
                    offered through the Services.

                    <br /><br /><br />

                    <h2 class="title mb-6">Responsibility for privacy</h2>
                    <p>template<br /><br />
                    <p>The processor for data collection and data processing on our website is under data protection
                      law<br /><br />
                      Email: <a
                        href="mailto:&#108;&#116;&#116;&#114;&#102;&#102;&#118;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;"
                        target="_blank">support&#64;gogomoneymaker.com</a><br />
                      Web: <a href="https://www.gogomoneymaker.com"
                        target="_blank">https://www.gogomoneymaker.com</a><br />
                      (hereafter “we” or "the operator")
                    </p>

                    <br /><br />
                    <h5 class="title">Web Hosting</h5>
                    <p>Our website is operated on server systems of Amazon Web Services, Inc., P.O. Box 81226 -
                      Seattle, WA
                      98108-1226. As part of our collaboration, I do not share any personal identifiable information
                      about
                      your visit to our website with Amazon Web Services, Inc. However, it may happen that Amazon Web
                      Services, Inc., e.g. during maintenance work, at least potentially gaining access to personal
                      data.
                      However, privacy agreements with Amazon Web Services, Inc. ensure that your privacy is
                      protected.
                    </p>
                    <br /><br />

                    <h2 class="title mb-6">Type and extent of collected data</h2>
                    <p>When you access our website, different information about your visit is collected. This
                      information
                      includes usage information such as the webpages you visit, the content you read, access times,
                      device
                      information, information about your operating system and web browser, and IP addresses. If, in
                      addition
                      to the pure access to our webpages, you also use services such as a contact form, a commentary
                      function
                      or any other function that requires the input of your data on our website, additional
                      information will
                      not be collected and processed in addition to the aforementioned data.
                    </p>
                    <br /><br />

                    <h2 class="title mb-6">Collecting data when using the contact form of our website</h2>
                    <p>If you would like to contact us, you can use the contact form on our website. If you do it, we
                      will need
                      the following data categories from you: name, e-mail address, your message. All the data such as
                      your
                      name or address, contact information such as your telephone number or e-mail address, and
                      content data
                      such as typed text or sent media are not collected for any purpose and they are under your own
                      responsibility. We will receive them on our business email account and we will never share them
                      with
                      third part services.<br /><br />
                      To protect the security of your data during transmission, our website use Hypertext Transfer
                      Protocol
                      Secure (HTTPS) encryption techniques which include the Secure Sockets Layer (SSL).</p>
                    <br /><br />
                    <h2 class="title mb-6">Data storage</h2>
                    <p>We will retain your Personal Data only for as long as is necessary for the purposes set out in
                      this
                      Privacy Policy.<br />
                      The User voluntarily provides the Data Controller with his/her personal data by creating his/her
                      own
                      account. The personal data thus provided are collected and processed by the Data Controller to
                      generate
                      and manage the User's account. The data will be processed for as long as the account is active
                      and
                      deleted upon the User's request for deactivation of the account or, automatically, if the User
                      does not
                      use the account for a certain period of time.
                      We will retain and use your Personal Data to the extent necessary to comply with our legal
                      obligations
                      (for example, if we are required to retain your data to comply with applicable laws), resolve
                      disputes,
                      and enforce our legal agreements and policies.<br />
                      We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained
                      for a
                      shorter period of time, except when this data is used to strengthen the security or to improve
                      the
                      functionality of our Service, or we are legally obligated to retain this data for longer time
                      periods.
                      Personal data, in any case, will not be subject to dissemination and, therefore, will not be
                      brought to
                      the attention of unspecified parties, in any form whatsoever, such as by making them available
                      or
                      consulting them, without the express consent of the Data Subject, when requested.
                    </p>
                    <br /><br />
                    <h2 class="title mb-6">Automatic data collection while using our website</h2>
                    <p>If you access our website, we and / or our host will automatically collect informations
                      anonymously of a
                      general nature. The collection and processing of these anonymous data is based on our legitimate
                      interest. The collected information (so-called server log files) includes the type of your web
                      browser,
                      the operating system you are using, the domain name of your Internet service provider, the IP
                      address,
                      the time and duration of the access, the requested webpages, the amount of data transferred and
                      the
                      referrers URL of the previously visited website. This is only information that is not used to
                      draw
                      conclusions about you. This information is technically necessary to correctly deliver the
                      contents of
                      webpages requested by you and is mandatory when using the internet. Anonymised information of
                      this kind
                      is statistically evaluated by us to optimize our website and the underlying technology. The
                      purpose of
                      processing this information is to provide our online content, including features and content,
                      measure
                      our offers, respond to and communicate with you, and, if necessary, perform security measures.
                    </p><br /><br />
                    <h2 class="title mb-6">Cookies</h2>
                    <p>
                      Like many other website, our website use so-called "cookies". Cookies are small text files that
                      are
                      transferred from a web server to your computer. In this way, we automatically receive certain
                      data such.
                      IP address, browser used, operating system from your computer and your connection to the
                      Internet.
                      Temporary cookies or so-called "session cookies" contain information that relates to the current
                      visit
                      to our website. This can e.g. the contents of a shopping cart or your login status. Temporary
                      cookies
                      are deleted when you visit our website or when you close your browser. Persistent cookies
                      usually
                      contain information about your login status or your interests on our website, which are used for
                      coverage measurement or other marketing purposes. Persistent cookies remain stored on your
                      computer even
                      after you close your browser. If we make available or use third-party services on our website
                      (such as
                      Google Analytics), these third-party providers also store cookies on your computer. Cookies can
                      not be
                      used to launch programs or to transfer viruses to a computer. We can use the information
                      contained in
                      cookies to facilitate navigation and ensure the correct display of our webpages. In no case will
                      the
                      data processed by us be passed on to third parties or a link with personal data will be
                      established
                      without your consent. Of course, you can also view our website without cookies. Internet
                      browsers are
                      usually set to accept cookies. You can deactivate the use of cookies at any time via the
                      settings of
                      your browser. You also have the option of deleting previously saved cookies from your computer.
                      Please
                      use the help features of your internet browser to learn how to change your cookie settings or
                      delete
                      previously saved cookies. If you would like a general objection to the use of cookies for
                      marketing
                      purposes, you can do so at various online service providers as:
                    </p>
                    <div>
                      <ul>
                        <li><a href="http://www.aboutads.info/choices" target="_blank">About ads</a> (for the US)</li>
                        <br />
                        <li><a href="http://www.youronlinechoices.com" target="_blank">Your online choices</a> (for
                          the EU)
                        </li>
                      </ul>
                    </div>
                    <p>Please note that some features of our website may not work if you have disabled the use of
                      cookies.</p>
                    <br /><br />
                    <h2 class="title mb-6">Analysis & Marketing Services</h2>
                    <p>With the help of the following analysis and marketing services, we are able to track your
                      behavior on our
                      website in order to improve our service and / or to show you interest-based offers. You may
                      object to
                      data processing as described in the following sections.</p><br /><br />

                    <h2 class="title mb-6">Google Analytics</h2>
                    <p>This website uses Google Analytics (Google Inc.). Google Analytics uses so-called "cookies",
                      text files
                      that are stored on your computer and that allow an analysis of the use of our website by you.
                      The
                      information generated by the cookie about your use of our website is usually transmitted to and
                      stored
                      by Google on servers in the United States. However, due to the activation of IP anonymization on
                      our
                      website, your IP address will be shortened by Google beforehand within member states of the
                      European
                      Union or other parties to the Agreement on the European Economic Area. Only in exceptional cases
                      will
                      the full IP address be sent to a Google server in the US and shortened there.</p>
                    <br /><br />
                    <p>On behalf of the operator of this website, Google will use this information to evaluate your use
                      of the
                      website, to compile reports on website activity and to provide other services related to website
                      activity and internet usage to the website operator. The IP address provided by Google Analytics
                      as part
                      of Google Analytics will not be merged with other Google information.</p>
                    <br /><br />
                    <p>You can prevent the storage of cookies by a corresponding setting of your browser software;
                      However, we
                      point out that in this case, you may not be able to use all the features of our website in full.
                      You can
                      also prevent the collection of data generated by the cookie and related to your use of our
                      website
                      (including your IP address) to Google and the processing of this data by Google by downloading
                      the
                      browser plug-in available under the following link and install: Browser Add On to disable Google
                      Analytics.</p>
                    <br /><br />
                    <p>Google provides further information on the use of data by Google as well as on your options for
                      setting
                      up and disagreeing on its website. Please browse the following links:</p>
                    <div>
                      <ul>
                        <li><a href="https://www.google.com/intl/en/policies/privacy/partners" target="_blank">Google
                            Partners – Privacy Policy</a> for information about how Google uses your data when you
                          use
                          website or uses apps from Google Partners.</li><br />
                        <li><a href="https://www.google.com/policies/technologies/ads" target="_blank">Promotional
                            informations</a></li><br />
                        <li><a href="https://www.google.com/settings/ads" target="_blank">Manage your informations
                            used by
                            Google to show ads</a></li>
                      </ul>
                    </div>
                    <br /><br />
                    <h2 class="title mb-6">Analysis & Marketing Services</h2>
                    <p>On our website, we may use third-party services, such as to display videos, maps, fonts (web
                      fonts) or
                      other content. The provision of such content requires that you submit your IP address to the
                      third-party
                      vendor so that they can properly deliver the content to your browser. We make every effort to
                      include as
                      few external content as possible on our website and only to include content whose providers
                      use your IP
                      address solely to provide the requested content. However, we would point out that third-party
                      vendors
                      can also use so-called "pixel tags" or "web beacons" to statistically analyze information such
                      as the
                      amount of traffic on visited website. Such information may be stored in a pseudonymous form in
                      cookies
                      on your computer. This includes information about your browser or the operating system of your
                      computer,
                      information about referring website, visiting hours and times, and the webpages visited on our
                      website.
                      This data can be linked to information from other sources. To prevent the use of cookies or
                      delete
                      cookies already stored on your computer, please refer to the help information of your web
                      browser.</p>
                    <br />
                    <p>The following third-party services are included on our website:</p><br />
                    <h2 class="title mb-6">Google Service</h2>
                    <p>We use interactive maps of Google Maps, web-enabled fonts from Google Fonts, and jQuery
                      scripts
                      integrated with the Google API on our website. These are services provided by Google LLC, 1600
                      Amphitheater Parkway, Mountain View, CA 94043, USA.</p>
                    <div>
                      <ul>
                        <li><a href="https://www.google.com/policies/privacy/" target="_blank">Google Privacy
                            Policy</a>
                        </li><br />
                        <li><a href="https://adssettings.google.com/authenticated" target="_blank">Google Privacy
                            Policy
                            opt-out options</a></li>
                      </ul>
                    </div>
                    <br />
                    <br /><br />
                    <h2 class="title mb-6">Discord</h2>
                    <p>On our website, we use buttons to link to Discord (Discord Inc., 444 De Haro Street - Suite
                      200, San
                      Francisco, CA 94107 - United States of America). The use of Discord buttons is based on
                      specific data
                      transmission requirements. Discord is certified under the Privacy Shield Agreement, thereby
                      ensuring
                      compliance with European data protection law. Discord buttons are used to interact with our
                      visitors and
                      to display specific content. If you use the Discord plugins included on our website, e.g. By
                      clicking
                      the Discord button or by sharing the URL of a page in your Discord profile, your computer
                      sends certain
                      information about your use of our website to a Discord server. If you have a Discord user
                      profile,
                      Discord can associate that information with your Discord account and create usage profiles
                      about your
                      online behavior. For more information about how Discord collects and processes data, please
                      browse:</p>
                    <div>
                      <ul>
                        <li><a href="https://discord.com/terms/privacy-policy" target="_blank">Discord Privacy
                            Policy</a>
                        </li>
                      </ul>
                    </div>
                    <br />
                    <br /><br />
                    <h2 class="title mb-6">Telegram Messenger</h2>
                    <p>On our website, we use buttons to link to Telegram Messenger (Telegram Messenger FZ-LLC,
                      Dubai, Dubai,
                      United Arab Emirates). The use of the Telegram Messenger button is based on specific data
                      delivery
                      requirements. Telegram Messenger is certified under the Privacy Shield Agreement, thus
                      guaranteeing
                      compliance with European data protection law. If you use the Telegram Messenger button on our
                      website,
                      e.g. share the URL of a page in your LinkedIn profile, your computer sends certain data to a
                      LinkedIn
                      server that enables LinkedIn to create a usage profile about your online behavior. For
                      information about
                      the nature and scope of LinkedIn data collection and processing, please browse:</p>
                    <div>
                      <ul>
                        <li><a href="https://telegram.org/privacy?setln=en" target="_blank">Telegram Messenger
                            Privacy
                            Policy</a></li>
                      </ul>
                    </div>

                    <br /><br /><br />
                    <h2 class="title mb-6">Passing on your data to third parties</h2>
                    <p>Your data will only be passed on to third parties if this is permitted or prescribed under
                      European data
                      protection law. This is the case, on the one hand, if you have expressly consented to the
                      disclosure of
                      your data and / or the disclosure is necessary for the performance of the contract. A transfer
                      of your
                      data is also permissible under data protection law if the enforcement of regulations of other
                      laws (for
                      example criminal law regulations) requires disclosure and does not conflict with this transfer
                      from a
                      data protection point of view. The transfer of your data is also justifiable if, in our
                      opinion, there
                      is a legitimate interest in passing on the relevant information (for example, when placing an
                      order with
                      a third party, when using a representative or against a web host). The transfer of your data
                      in the
                      context of a contract processing contract takes place exclusively on the basis of Art. 28
                      GDPR. You can
                      rest assured that the possible disclosure of personal data to third parties will always be
                      checked in
                      advance under data protection law.</p>
                    <br /><br /><br />
                    <h2 class="title mb-6">Transmission of your data to third countries</h2>
                    <p>If we process personal information in a third country (ie a country outside the European
                      Union or the
                      European Economic Area) or, for example, in connection with the use of a service by third
                      parties, this
                      is done solely for the purpose of fulfilling our contractual obligations, with your consent or
                      on the
                      basis of a corresponding legal obligation. The transmission or processing of your data to
                      third
                      countries only takes place in the case of the legal and / or contractual legality of such
                      transmission
                      or processing as well as in the case of the special requirements of Art. 44 et seq. GDPR. For
                      example,
                      there are special conditions if the third country can be officially recognized as having a
                      data
                      protection level appropriate to the EU. Also relevant guarantees or the agreement of
                      officially
                      recognized contractual obligations (so-called standard contractual clauses) are special
                      conditions for
                      the transfer of data to third countries.</p>
                    <br /><br /><br />
                    <h2 class="title mb-6">Transmission of your data outside the EU</h2>
                    <p>The Data Controller acknowledges that personal data of Data Subjects may be disclosed to
                      entities located
                      in countries outside the European Union for the pursuit of the above purposes. Such transfer
                      will take
                      place only upon the existence of international agreements or adequacy decisions and the
                      adoption of
                      other measures required by applicable processing regulations. A copy of any personal data
                      transferred
                      abroad, as well as the list of third countries/international organizations to which personal
                      data have
                      been transferred, may be requested from the Data Controller at the email address <a
                        href="mailto:&#108;&#116;&#116;&#114;&#102;&#102;&#118;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;"
                        target="_blank">support&#64;gogomoneymaker.com</a></p>
                    <br /><br /><br />
                    <h2 class="title mb-6">Your rights as an affected person</h2>
                    <p>At this point we would like to inform you briefly about the data protection rights that you
                      can exercise
                      towards us.</p><br /><br />
                    <h2 class="title mb-6">Right to information / right of rectification</h2><br />
                    <p>You have the right to receive information about your stored personal data or request copies
                      of this data
                      at any time. Please send us an e-mail to support&#64;gogomoneymaker.com. Only true personal
                      data may be processed.
                      If, for example, you discover that a date about you is incorrect, incomplete, or inaccurate or
                      incomplete, for example, by exercising your right to information, We are generally obliged to
                      promptly
                      correct it.</p><br /><br /><br /><br />

                    <h2 class="title mb-6">Cancellation right / blocking right</h2><br />
                    <p>We process your data only for the purposes stated in this privacy policy. As a matter of
                      principle, these
                      data are only needed to process the data processing you require (for example, processing your
                      message,
                      checking your request). In some cases, we may be required by law to keep your information for
                      a limited
                      period of time. If we do not need your data during this period, they will be blocked or their
                      processing
                      restricted. You have the right to request the immediate deletion of your data or to demand a
                      restriction
                      on the processing of your data. In addition, you have the right to have the data that we store
                      about you
                      transmitted to you or another person in charge before being deleted.</p><br /><br />
                    <br />
                    <h2 class="title mb-6">Right of objection / right of withdrawal</h2><br />
                    <p>Insofar as you are entitled to a legal right to object to the data processing described in
                      this Privacy
                      Policy, you will be notified thereof. You also have the opportunity to exercise your
                      opposition in the
                      appropriate places. In addition, you have the right to revoke existing consent for the
                      collection or
                      processing of your data with effect for the future or to object to the future collection and
                      processing
                      of your personal data in advance at any time. This contradiction can occur, in particular, if
                      the
                      processing of your data serves the purpose of direct mailing.</p><br /><br />
                    <p>You also have the right not to be subjected to a decision based solely on automated
                      processing, including
                      profiling, which produces legal effects with respect to you or which affects you in a similar
                      and
                      meaningful way, unless such a decision:</p>
                    <div>
                      <ul>
                        <li>(a) is necessary for the conclusion or performance of a contract between you and the
                          Operator;
                        </li><br />
                        <li>(b) is authorized by the law of the Union or the Member State to which the Operator is
                          subject;
                        </li><br />
                        <li>(c) is based on your express consent. In the cases referred to in the aforementioned
                          points a)
                          and c), you have the right to obtain human intervention from the Operator, to express your
                          opinion and to challenge the decision. </li>
                      </ul>
                    </div>
                    <p>In the case where you need to demonstrate compelling legitimate prevailing reasons or the
                      exercise or
                      defense of a right, you may submit requests to support&#64;gogomoneymaker.com indicating in
                      the subject line "Privacy
                      - Exercise of privacy rights”, specifying which right you intend to exercise and providing the
                      Operator
                      with information useful for your identification. You also have the right to file a complaint
                      with the
                      supervisory authority, particularly in the member state where you normally reside, where you
                      work, or
                      where the alleged violation occurred, as well as to take appropriate legal action.</p>
                    <br /><br /><br />
                    <h2 class="title mb-6">Contact the data protection officer</h2>
                    <p>You can contact the data protection officer directly via the following e-mail address:<br />
                      <a href="mailto:&#108;&#116;&#116;&#114;&#102;&#102;&#118;&#64;&#103;&#109;&#97;&#105;&#108;&#46;&#99;&#111;&#109;"
                        target="_blank">support&#64;gogomoneymaker.com</a>
                    </p><br /><br />
                    <p>If you disagree with our handling of your personal data, you can submit a complaint to the
                      relevant
                      regulatory authority.</p>
                    <br /><br /><br />
                    <h2 class="title mb-6">Nature of conferment</h2>
                    <p>With the exception of what has been specified about navigation data, the failure to provide
                      such data
                      will make it impossible for the Data Controller to follow up the interaction with the Site by
                      the
                      Interested Party and, for the Interested Party, to use the Site and all its functionalities,
                      the User is
                      free to provide his/her personal data in order to take advantage of the functionalities and
                      services
                      made available in the Site. The only consequence resulting from the failure to provide such
                      data will be
                      the impossibility, for the Interested Party, to make use of the relevant services, without
                      this
                      entailing any prejudicial consequences.</p>
                    <br /><br /><br />
                    <h2 class="title mb-6">Change of privacy policy</h2>
                    <p>We reserve the right to occasionally adapt parts of this Privacy Policy to always comply with
                      current
                      legal requirements or to implement changes in our services in the Privacy Policy, e.g. when
                      introducing
                      new services. Your new visit will be subject to the new privacy policy. If your prior consent
                      is
                      required for the introduction of a new service, you will be informed accordingly in good time
                      and your
                      consent will be requested.</p><br />

                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- /wrapper -->